import { buildApiClient } from "@core/api-client/RetryableBearerApiClient";
import type Feature from "@core/features/feature";

export async function listAsync(): Promise<Feature[]> {
    return await buildApiClient(window.env.ACTIVITIES_API_URL).getAsync("/api/v1/features");
}